import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "store";
import { openModal } from "store/modals/slice";
import { ModalTypes } from "configs/types";

export const useContentPreviewModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const openPreview = (userId: number, documentId: number) => {
    dispatch(openModal({ activeModal: ModalTypes.contentPreview }));

    const returnUrl = encodeURIComponent(location.search);

    navigate(
      `${location.pathname}?activeModal=${ModalTypes.contentPreview}&userId=${userId}&documentId=${documentId}&returnUrl=${returnUrl}`,
    );
  };

  return { openPreview };
};
